// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import React from 'react';
import DoubleLeftOutlinedSvg from "@ant-design/icons-svg/es/asn/DoubleLeftOutlined";
import AntdIcon from '../components/AntdIcon';

var DoubleLeftOutlined = function DoubleLeftOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DoubleLeftOutlinedSvg
  }));
};

DoubleLeftOutlined.displayName = 'DoubleLeftOutlined';
export default React.forwardRef(DoubleLeftOutlined);